import { render, staticRenderFns } from "./NotifyCard.vue?vue&type=template&id=90426d48&scoped=true"
import script from "./NotifyCard.vue?vue&type=script&lang=js"
export * from "./NotifyCard.vue?vue&type=script&lang=js"
import style0 from "./NotifyCard.vue?vue&type=style&index=0&id=90426d48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90426d48",
  null
  
)

export default component.exports